import { useEffect, useMemo, useRef } from 'react'
import { getNodes } from 'utils/graphql'

/**
 * Takes a relay object and returns the nodes, memoized
 * @param data An object containing edges
 */
export function useNodes<T>(
  data:
    | { edges?: ({ node?: T | null | undefined } | null)[] | null | undefined }
    | undefined,
  filter?: (node: T) => boolean
) {
  const filterRef = useRef(filter)

  useEffect(() => {
    filterRef.current = filter
  }, [filter])

  return useMemo(() => getNodes(data, filterRef.current), [data])
}
